// API URL configuration
// In production (same domain), use relative URL
// In development/preview, use the environment variable
import axios from 'axios';

const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (!hostname.includes('preview.emergentagent.com') &&
        !hostname.includes('localhost') &&
        !hostname.includes('127.0.0.1')) {
      return '/api';
    }
  }
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (backendUrl) {
    return `${backendUrl}/api`;
  }
  return '/api';
};

export const API_URL = getApiUrl();

// Send httpOnly session cookie on every request. Backend still accepts the
// Authorization: Bearer header as a fallback for existing sessions.
axios.defaults.withCredentials = true;
